export default __webpack_public_path__ + "static/media/cny-flag.ff5a34a1.svg";